import DepartmentwiseChart from 'components/charts/DepartmentwiseChart';
import DepartmentwiseQualifiation from 'components/charts/DepartmentwiseQualifiation';
import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLazyGetDepartmentAvgQuery } from 'service/institutionQuery/institutionQuery';
import { RootState } from 'store/rootReducer';
import 'assets/scss/modules/department.scss';

interface DepartmentData {
  [key: string]: {
    averageMarks: number;
    blocked: number;
    qualified: number;
  };
}

const DepartmentwiseStats = () => {
  const [selectedDate, setSelectedDate] = useState<number>(
    new Date().getFullYear() + 1
  );
  const [department, setDepartment] = useState<DepartmentData>({});
  const institution = useSelector(
    (state: RootState) => state?.user?.user?.info?.year
  );
  const [getDepartmentAvg, { isFetching }] = useLazyGetDepartmentAvgQuery();

  const options = useMemo(() => {
    const startYear = institution
      ? new Date(institution).getFullYear()
      : new Date().getFullYear();
    const endYear = new Date().getFullYear();

    return Array.from({ length: endYear - startYear + 1 }, (_, idx) => {
      const year = startYear + idx;
      return {
        label: `${year} - ${year + 1}`,
        value: year + 1
      };
    });
  }, [institution]);

  useEffect(() => {
    if (selectedDate) {
      getDepartmentAvg(String(selectedDate))
        .unwrap()
        .then(info => {
          setDepartment(info?.data || {});
        })
        .catch(err => {
          console.error('Failed to fetch department data:', err);
          setDepartment({});
        });
    }
  }, [selectedDate, getDepartmentAvg]);

  return (
    <>
      <Row className="justify-content-between align-items-center mb-4 g-3">
        <Col xs="auto">
          <h4>Department Performance</h4>
          <p className="text-body-tertiary lh-sm mb-0">
            Showcase the total number of passed and failed students, along with
            their average performance metrics.
          </p>
        </Col>
        <Col xs={8} sm={4}>
          <div className="d-flex gap-3">
            <Form.Select
              size="sm"
              value={selectedDate}
              onChange={e => setSelectedDate(Number(e.target.value))}
            >
              {options.map(doc => (
                <option key={doc.value} value={doc.value}>
                  {doc.label}
                </option>
              ))}
            </Form.Select>
          </div>
        </Col>
      </Row>
      <Row className="g-4">
        <Col xs={12} lg={6}>
          <div className="card shadow-sm p-4">
            <h5 className="card-title">Department-wise Performance</h5>
            <DepartmentwiseChart data={department} loading={isFetching} />
          </div>
        </Col>
        <Col xs={12} lg={6}>
          <div className="card shadow-sm p-4">
            <h5 className="card-title">Department-wise Qualification</h5>
            <DepartmentwiseQualifiation
              data={department}
              loading={isFetching}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default DepartmentwiseStats;
